<template>
    <div id="advert-type">
        <div class="breadcrumb">信息流广告</div>
        <div class="advert-content">
            <el-row>
                <el-col :span="8">
                    <div class="advert-item" @click="toAdvertManage(0)">动态</div>
                </el-col>
                <el-col :span="8">
                    <div class="advert-item" @click="toAdvertManage(1)">文章</div>
                </el-col>
                <el-col :span="8">
                    <div class="advert-item" @click="toAdvertManage(2)">话题</div>
                </el-col>
            </el-row>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {

            }
        },
        mounted() {

        },
        methods: {
            toAdvertManage(type) {
                location.href = '/#/yunying/advert/advertManage?advertType=' + type;
            },
        }
    }
</script>
<style scoped>
    .advert-content {
        min-width: 960px;
        padding-top: 80px;
        text-align: center;
    }

    .advert-item {
        display: inline-block;
        width: 300px;
        height: 300px;
        line-height: 300px;
        color: #ffffff;
        font-size: 24px;
        text-align: center;
        background-color: #999999;
        cursor: pointer;
    }
</style>


// WEBPACK FOOTER //
// advertType.vue?6385f12b